<div class="cash-container">

    <div class="cash-header">
        <span>Cash Denomination</span>
        <span (click)="closepopup()" class="kx-modal-close"><i class="fa fa-times-circle" aria-hidden="true"></i></span>
    </div>

    <div class="cash-content" *ngIf="updateForm">
        <table class="cash-table">
            <thead>
                <tr>
                    <th>Rs</th>
                    <th>Qty</th>
                    <th>Action</th>
                    <th>Amount</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let row of cash_den_data">
                    <td>{{row.cash_denomination}}</td>

                    <td>
                        <input type="number" [ngModel]="row.qty || 0" (ngModelChange)="onQtyChange(row, $event)">
                    </td>
                    <td class="action-cell">

                        <button class="minus-btn" (click)="decreaseQty(row)">
                            -
                        </button>

                        <button class="plus-btn" (click)="increaseQty(row)">
                            +
                        </button>

                    </td>

                    <td>
                        {{ row.cash_denomination * (row.qty || 0) }}
                    </td>
                </tr>

                <tr>
                    <td><b>Total</b></td>
                    <td><b>{{totalQty}}</b></td>
                    <td></td>
                    <td><b>{{totalAmount}}</b></td>
                </tr>

                <tr>
                    <td>Net Cash</td>
                    <td colspan="2"></td>
                    <td>{{netCash}}</td>
                </tr>

                <tr>
                    <td>Balance</td>
                    <td colspan="2"></td>
                    <td class="balance-positive">
                        {{balance}}
                    </td>
                </tr>

            </tbody>

        </table>

    </div>

    <div class="submit-section">
        <button class="submit-btn" (click)="onSubmit($event)">
            Submit ✓
        </button>
    </div>

</div>